import type { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  cache: {
    cacheLocation: process.env.REACT_APP_CACHE_LOCATION || "localStorage",
    storeAuthStateInCookie: false,
  },
  auth: {
    clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID || "",
    authority: process.env.REACT_APP_AZURE_AD_AUTHORITY || "",
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "",
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || "",
    navigateToLoginRequestUrl: Boolean(process.env.REACT_APP_NAVIGATE_TO_LOGIN),
  },
};

export const loginRequest = {
  scopes: [process.env.REACT_APP_AZURE_AD_SCOPE || ""],
};
